import type { Lang } from "../index";

export interface PricingPageCopy {
  seo: { title: string; description: string };
  eyebrow: string;
  heading: string;
  intro: string;
  primaryCta: string;
  secondaryCta: string;
}

const en: PricingPageCopy = {
  seo: {
    title: "Pricing — Minuta",
    description:
      "Minuta pricing for professionals in English, Portuguese, and Spanish meetings: 7-day full trial, Free with 1 hour/month, and Pro for unlimited secure transcription, copilot, summary, and speaker ID.",
  },
  eyebrow: "Pricing",
  heading: "Choose how you run multilingual meetings.",
  intro:
    "Start with full access for 7 days. After that, Free includes 1 hour/month of secure transcription and translation. Upgrade to Pro for unlimited recording, the in-meeting copilot, automatic summary, and speaker identification.",
  primaryCta: "See plans",
  secondaryCta: "Download app",
};

const pt: PricingPageCopy = {
  seo: {
    title: "Preços Minuta — Free e Pro para reuniões multilíngues",
    description:
      "Preços do Minuta para profissionais em reuniões em inglês, português e espanhol: 7 dias de acesso completo, Free com 1 hora/mês e Pro com gravação, copiloto, ata e identificação de falantes.",
  },
  eyebrow: "Preços",
  heading: "Escolha como você quer rodar reuniões multilíngues.",
  intro:
    "Comece com acesso completo por 7 dias. Depois disso, o Free inclui 1 hora/mês de transcrição e tradução locais. Faça upgrade para Pro para gravação ilimitada, copiloto na reunião, ata automática e identificação de falantes.",
  primaryCta: "Ver planos",
  secondaryCta: "Baixar app",
};

const es: PricingPageCopy = {
  seo: {
    title: "Precios — Minuta",
    description:
      "Precios de Minuta para profesionales en reuniones en inglés, portugués y español: 7 días con acceso completo, Gratis con 1 hora/mes y Pro para transcripción segura ilimitada, copiloto, acta e identificación de hablantes.",
  },
  eyebrow: "Precios",
  heading: "Elige cómo quieres correr reuniones multilingües.",
  intro:
    "Empieza con acceso completo por 7 días. Después, Gratis incluye 1 hora/mes de transcripción y traducción seguras. Sube a Pro para grabación ilimitada, copiloto en la reunión, acta automática e identificación de hablantes.",
  primaryCta: "Ver planes",
  secondaryCta: "Descargar app",
};

export const pricingPageCopy: Record<Lang, PricingPageCopy> = { en, pt, es };
